import {TicketTemplateFragmentFragment} from "../../../../__generated__/graphql/types";
import {produce} from "immer";
import React, {useReducer} from "react";

export const DefaultState = {
    drawerOpen: false,
    selectedTicketTemplateID: null as string
}

export type State = typeof DefaultState;

export type Action = {
    type: 'OPEN_PANEL',
    payload: {
        selectedTicketTemplateID: string
    }
} | {
    type: 'CLOSE_PANEL'
}

export const Reducer: React.Reducer<State, Action> = (_state, action) => {
    return produce(_state, (draft) => {
        switch (action.type){
            case 'OPEN_PANEL':
                draft.drawerOpen = true;
                draft.selectedTicketTemplateID = action.payload.selectedTicketTemplateID;
                return draft;
            case 'CLOSE_PANEL':
                draft.drawerOpen = false;
                return draft;
            default:
                return draft;
        }
    })
}

export function useVeriflytTicketTemplateSelectApi(data: TicketTemplateFragmentFragment[]){

    const [ state, dispatch ] = useReducer(Reducer, DefaultState);

    return {
        state: {
            ...state,
            ticketTemplates: data
        },
        openPanel: (selectedTicketTemplateID: string) => dispatch({ type: 'OPEN_PANEL', payload: { selectedTicketTemplateID } }),
        closePanel: () => dispatch({ type: 'CLOSE_PANEL' })
    }
}

export type VeriflytTicketTemplateSelectApi = ReturnType<typeof useVeriflytTicketTemplateSelectApi>

export const VeriflytTicketTemplateSelectApiContext = React.createContext<VeriflytTicketTemplateSelectApi>(null);